import React, { CSSProperties } from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import autobind from "class-autobind"
import { IJobDocument } from "../../models"
import AddJobDialogForChip from "./AddJobDialogForChip"
import * as jobHelper from "../../helpers/jobHelper"
import { grey500, grey700, green500, red500 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
interface IProps {
	label: string
	maxWidth?: number
	filterHierarchyId?: string
	restrictHierarchy?: boolean
	disabled?: boolean
	multiSelectable?: boolean
	selectedJobs?: IJobDocument[]
	error?: string
	labelStyle?: CSSProperties
	handleSave?(jobs: IJobDocument[]): void

	//Employee->Timecard->PunchDrawerTable
	isPunchListTable?: boolean
	jobColWidth?: number

	//it's for client's shift
	clientId?: string
	//it's for punch to assigned job only
	punchEmployeeId?: string
}
interface IState {
	selectedJobs: IJobDocument[]
	openChooseDialog: boolean
}

export default class JobsChip extends React.Component<IProps, IState>  {
	constructor(props: IProps) {
		super(props)
		this.state = {
			selectedJobs: props.selectedJobs,
			openChooseDialog: false,
		}
		autobind(this)
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ selectedJobs: nextProps.selectedJobs })
	}

	render() {
		return (!this.props.restrictHierarchy || jobHelper.getAllowJobByHierarchy(this.props.filterHierarchyId)) && (
			<div>
				<div style={this.props.labelStyle || { fontSize: 12, color: "rgba(0, 0, 0, 0.298)", display: "flex" }}>
					<div>
						{this.props.disabled && !this.props.selectedJobs.length ?
							null :
							this.props.label ?
								this.props.label :
								null
						}
					</div>
					<div style={{ color: red500, marginLeft: 10 }}>{this.props.error}</div>
				</div>
				<div style={{ display: "flex", flexWrap: "wrap" }}>
					{this.state.selectedJobs.length > 0 &&
						this.state.selectedJobs.map((job, index) =>
							<Chip
								data-intercom-target={"Select-Job"}
								key={index}
								style={{ justifyContent: this.props.isPunchListTable && "space-between", margin: 2, height: 35, width: this.props.isPunchListTable ? this.props.jobColWidth : "min-content" }}
								onRequestDelete={this.props.disabled ?
									null :
									() => this.setState({ selectedJobs: this.state.selectedJobs.filter(i => i.Id !== job.Id) }, () =>
										this.props.handleSave(this.state.selectedJobs)
									)
								}
							>
								<div
									className="TextOverflow"
									title={job.Name}
									style={{
										maxWidth: this.props.isPunchListTable ? this.props.jobColWidth - 50 : this.props.maxWidth ? this.props.disabled ? this.props.maxWidth : this.props.maxWidth - 25 : 150,
										color: (job.Deleted || !job.Active) ? red500 : job.Id === AccountStore.DiffJobId && green500,
										fontSize: this.props.isPunchListTable && 12
									}}
								>
									{(job.Deleted || !job.Active) ? `${job.ExternalId || job.Name} ${job.Deleted ? strings.Removed : strings.Inactivated}` : job.Name}
								</div>
							</Chip>
						)
					}
					{!this.props.disabled && (this.props.multiSelectable ? true : !this.state.selectedJobs.length) &&
						<IconButton
							data-intercom-target={"Btn-Open-Job-Selection-Dialog"}
							style={{ height: this.props.isPunchListTable ? 18 : 35, width: this.props.isPunchListTable ? 18 : 35, marginTop: this.props.isPunchListTable && 10, padding: 0, margin: 0, display: "inline-block" }}
							iconStyle={{ color: this.props.isPunchListTable ? grey500 : grey700, fontSize: this.props.isPunchListTable ? 18 : 24 }}
							onTouchTap={() => this.setState({ openChooseDialog: true })}
						>
							<FontIcon className="fa fa-plus-circle" />
						</IconButton>
					}
				</div>
				{this.state.openChooseDialog &&
					<AddJobDialogForChip
						jobs={this.state.selectedJobs}
						filterHierarchyId={this.props.filterHierarchyId}
						multiSelectable={this.props.multiSelectable === true}
						restrictHierarchy={this.props.restrictHierarchy}
						handleClose={() => this.setState({ openChooseDialog: false })}
						handleSave={selectedJobs => {
							this.setState({
								selectedJobs: [...this.state.selectedJobs, ...selectedJobs],
								openChooseDialog: false
							}, () => this.props.handleSave(this.state.selectedJobs))
						}}
						clientId={this.props.clientId}
						punchEmployeeId={this.props.punchEmployeeId}
					/>
				}
			</div>
		)
	}
}
